function fmt(n) {
    return n.toFixed(6);
}
export function emitDataRow1Port(freq, s11) {
    return `${freq}  ${fmt(s11.mag)}  ${fmt(s11.angDeg)}`;
}
export function emitDataRow2Port(freq, s11, s21) {
    // Touchstone 1.0 2-port column order: S11, S21, S12, S22.
    // S12 and S22 are zero-filled because NanoVNA hardware doesn't measure them.
    return (`${freq}  ${fmt(s11.mag)}  ${fmt(s11.angDeg)}` +
        `  ${fmt(s21.mag)}  ${fmt(s21.angDeg)}` +
        `  ${fmt(0)}  ${fmt(0)}` +
        `  ${fmt(0)}  ${fmt(0)}`);
}
//# sourceMappingURL=data-row.js.map